import { useQuery } from "@tanstack/react-query";
import {
  LoanIntentPurposeEnum,
  PositionSummaryResponse,
  SummaryQineticBeSharpProxyApi,
} from "../orchestrator-api-client";
import { purposeOptions } from "../constants/purpose-options.ts";

export type PersonalAreaData = PositionSummaryResponse & {
  purposeImgUrl: string;
  purposeImgAlt: string;
};

export default function useQuineticPositionSummary(positionId?: string) {
  return useQuery<PersonalAreaData>(
    getQuineticPositionSummaryQueryConfig(positionId),
  );
}

export function getQuineticPositionSummaryQueryConfig(positionId?: string) {
  return {
    queryKey: ["quinetic-summary", positionId],
    enabled: !!positionId,
    queryFn: () => getPersonalAreaData(positionId!),
  };
}

async function getPersonalAreaData(
  positionId: string,
): Promise<PersonalAreaData> {
  const { data } = await new SummaryQineticBeSharpProxyApi().getSummary(
    positionId,
  );

  const { purpose } = data;
  let imgUrlFetcher =
    imageUrlsFetchers[`./assets/${LoanIntentPurposeEnum.Other}.png`];
  if (`./assets/${purpose}.png` in imageUrlsFetchers) {
    imgUrlFetcher = imageUrlsFetchers[`./assets/${purpose}.png`];
  }
  const imgUrl = (await imgUrlFetcher()) as string;
  const purposeImgAlt =
    purposeOptions.find((option) => option.value === purpose)?.altText || "";

  return {
    ...data,
    purposeImgUrl: imgUrl,
    purposeImgAlt: purposeImgAlt,
  };
}

const imageUrlsFetchers = import.meta.glob("./assets/*.png", {
  query: "?url",
  import: "default",
});
